module.exports = __webpack_public_path__ + "img/landscape.d1d3729f.jpg";